export default "__VITE_ASSET__b6cb2509__"